var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eos-icons:admin-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 28.75C8.05375 27.2062 2.5 20.6525 2.5 13.75V6.25L15 1.25L27.5 6.25V13.75C27.5 20.655 21.9463 27.2062 15 28.75ZM5 7.5V13.75C5.07143 16.6402 6.08795 19.4273 7.89397 21.6848C9.69999 23.9423 12.196 25.5459 15 26.25C17.804 25.5459 20.3 23.9423 22.106 21.6848C23.912 19.4273 24.9286 16.6402 25 13.75V7.5L15 3.75L5 7.5Z",
    fill: "#101A24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 13.75C16.7259 13.75 18.125 12.3509 18.125 10.625C18.125 8.89911 16.7259 7.5 15 7.5C13.2741 7.5 11.875 8.89911 11.875 10.625C11.875 12.3509 13.2741 13.75 15 13.75Z",
    fill: "#101A24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.75 18.75C9.36611 19.8728 10.2695 20.8116 11.3677 21.4705C12.4659 22.1295 13.7194 22.4847 15 22.5C16.2806 22.4847 17.5341 22.1295 18.6323 21.4705C19.7305 20.8116 20.6339 19.8728 21.25 18.75C21.2188 16.38 17.0725 15 15 15C12.9162 15 8.78125 16.38 8.75 18.75Z",
    fill: "#101A24"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminOutlinedIcon);
export default __webpack_public_path__ + "static/media/admin-outlined-icon.74c14710cf8187c409b910875a82337f.svg";
export { ForwardRef as ReactComponent };